import React from 'react';
import { motion } from 'framer-motion';
import useEntryMotion from '../motion/useEntryMotion';

const directions = {
  up: { y: 40, x: 0 },
  down: { y: -40, x: 0 },
  left: { x: 40, y: 0 },
  right: { x: -40, y: 0 },
  none: { x: 0, y: 0 },
};

const Reveal = ({ children, direction = 'up', delay = 0, duration = 0.7, className, once = true }) => {
  const offset = directions[direction] || directions.up;
  const animateIn = useEntryMotion('scroll');

  // Without a running animation loop the hidden state would never be undone,
  // so the content is rendered as-is instead.
  if (!animateIn) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount: 0.2 }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
